import { AlertCircle } from "lucide-react";

type FinalizeBaselineModalProps = {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => void;
};

const FinalizeBaselineModal = ({
  isOpen,
  onClose,
  onConfirm,
}: FinalizeBaselineModalProps) => {
  if (!isOpen) return null;

  return (
    <div
      className="fixed inset-0 z-[1100] flex items-center justify-center bg-black/20 backdrop-blur-sm animate-[fadeIn_0.3s_ease]"
      onClick={onClose}
    >
      <div
        className="flex w-full max-w-md flex-col overflow-hidden rounded-[20px] border border-solid border-slate-200 bg-white shadow-sm transition-all duration-200"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="flex items-center justify-between border-b border-solid border-slate-200 px-6 py-5">
          <div>
            <h3 className="m-0 text-lg font-extrabold text-slate-800">
              Konfirmasi Finalisasi
            </h3>
          </div>
          <button
            onClick={onClose}
            className="flex h-8 w-8 items-center justify-center rounded-full border-none bg-slate-100 text-[1.1rem] text-slate-500 cursor-pointer"
          >
            ×
          </button>
        </div>

        <div className="px-6 py-6">
          <div className="flex gap-4 items-start">
            <div className="p-3 bg-amber-100 text-amber-700 rounded-xl shrink-0">
              <AlertCircle size={24} />
            </div>
            <div>
              <p className="text-slate-600 text-sm leading-relaxed m-0">
                Finalisasi baseline akan menjadikan perencanaan saat ini sebagai acuan execution.
                Apakah Anda yakin ingin melanjutkan?
              </p>
            </div>
          </div>
        </div>

        <div className="flex justify-end gap-3 border-t border-solid border-slate-200 bg-slate-50 px-6 py-4">
          <button
            onClick={onClose}
            className="rounded-xl border border-solid border-slate-300 bg-white px-5 py-2.5 text-sm font-semibold text-slate-700 transition-all duration-200 hover:bg-slate-50"
          >
            Batal
          </button>
          <button
            onClick={onConfirm}
            className="rounded-xl border-none bg-blue-600 px-5 py-2.5 text-sm font-bold text-white transition-all duration-200 hover:bg-blue-700 shadow-sm"
          >
            Lanjutkan Finalisasi
          </button>
        </div>
      </div>
    </div>
  );
};

export default FinalizeBaselineModal;
